/* ── Extra styles ────────────────────────────────────────────────────────────── */
const STYLES = `
  .user-role-btn.active-interviewer {
    background: rgba(124,58,237,.15);
    border-color: rgba(124,58,237,.4);
    color: #a78bfa;
  }
  .badge-purple {
    background: rgba(124,58,237,.15);
    border: 1px solid rgba(124,58,237,.3);
    color: #a78bfa;
  }
  .user-role-btn.active-interviewer {
    background: rgba(124,58,237,.15);
    border-color: rgba(124,58,237,.4);
    color: #a78bfa;
  }
  .ql-filter-bar {
    display:flex; align-items:center; gap:.75rem; flex-wrap:wrap;
    padding:.875rem 1.125rem; background:var(--bg-1);
    border:1px solid var(--line); border-radius:12px; margin-bottom:1rem;
  }
  .ql-search-wrap { position:relative; flex:1; min-width:160px; }
  .ql-search-icon {
    position:absolute; left:11px; top:50%; transform:translateY(-50%);
    color:var(--text-3); pointer-events:none;
  }
  .ql-search-input {
    width:100%; padding:7px 10px 7px 33px; background:var(--surface);
    border:1px solid var(--line-2); border-radius:9px; font-family:var(--body);
    font-size:.85rem; color:var(--text-1); outline:none;
    transition:border-color .15s,box-shadow .15s; box-sizing:border-box;
  }
  .ql-search-input::placeholder { color:var(--text-3); }
  .ql-search-input:focus { border-color:var(--blue); box-shadow:0 0 0 3px rgba(79,142,247,.12); }
  .ql-divider { width:1px; height:26px; background:var(--line); flex-shrink:0; }
  .ql-pills { display:flex; gap:.35rem; flex-wrap:wrap; }
  .ql-pill {
    padding:4px 11px; border-radius:100px; border:1px solid var(--line-2);
    background:transparent; font-family:var(--body); font-size:.76rem; font-weight:600;
    color:var(--text-2); cursor:pointer; transition:all .13s; white-space:nowrap;
  }
  .ql-pill:hover { background:var(--surface); color:var(--text-1); }
  .ql-pill.all.active   { background:rgba(255,255,255,.07); border-color:var(--line-2); color:var(--text-1); }
  .ql-pill.pending.active  { background:rgba(245,158,11,.12); border-color:rgba(245,158,11,.45); color:var(--amber); }
  .ql-pill.reviewed.active { background:rgba(79,142,247,.12); border-color:rgba(79,142,247,.45); color:var(--blue); }
  .ql-pill.accepted.active { background:rgba(34,197,94,.12);  border-color:rgba(34,197,94,.45);  color:var(--green); }
  .ql-pill.rejected.active { background:rgba(239,68,68,.12);  border-color:rgba(239,68,68,.45);  color:var(--red); }
  .ql-pill.verified.active { background:rgba(34,197,94,.12);  border-color:rgba(34,197,94,.45);  color:var(--green); }
  .ql-pill.unverified.active { background:rgba(245,158,11,.12); border-color:rgba(245,158,11,.45); color:var(--amber); }
  .ql-pill.user.active  { background:rgba(79,142,247,.12); border-color:rgba(79,142,247,.45); color:var(--blue); }
  .ql-pill.admin.active { background:rgba(245,158,11,.12); border-color:rgba(245,158,11,.45); color:var(--amber); }
  .ql-filter-select {
    padding:6px 9px; background:var(--surface); border:1px solid var(--line-2);
    border-radius:9px; font-family:var(--body); font-size:.85rem; color:var(--text-1);
    outline:none; cursor:pointer; transition:border-color .15s; min-width:140px;
  }
  .ql-filter-select:focus { border-color:var(--blue); box-shadow:0 0 0 3px rgba(79,142,247,.12); }
  .ql-meta { display:flex; align-items:center; gap:.5rem; margin-left:auto; flex-shrink:0; }
  .ql-count { font-size:.76rem; font-weight:500; color:var(--text-3); white-space:nowrap; }
  .ql-clear {
    padding:4px 10px; border-radius:8px; border:1px solid var(--line-2);
    background:transparent; font-family:var(--body); font-size:.76rem; font-weight:600;
    color:var(--text-2); cursor:pointer; transition:all .13s;
    display:flex; align-items:center; gap:4px;
  }
  .ql-clear:hover { background:rgba(239,68,68,.08); border-color:rgba(239,68,68,.3); color:var(--red); }

  .ql-refresh-btn {
    padding:6px 12px; border-radius:9px; border:1px solid var(--line-2);
    background:transparent; font-family:var(--body); font-size:.82rem; font-weight:600;
    color:var(--text-2); cursor:pointer; display:flex; align-items:center; gap:6px;
    transition:all .15s; flex-shrink:0;
  }
  .ql-refresh-btn:hover { background:var(--surface); color:var(--text-1); }
  .ql-refresh-btn.spinning svg { animation:spin .7s linear infinite; }
  @keyframes spin { to { transform:rotate(360deg); } }

  .sort-th { cursor:pointer; user-select:none; white-space:nowrap; }
  .sort-th:hover { color:var(--text-1); }
  .sort-th svg { display:inline; vertical-align:middle; margin-left:3px; opacity:.5; }
  .sort-th.asc svg, .sort-th.desc svg { opacity:1; color:var(--blue); }

  .emp-edit-grid { display:grid; grid-template-columns:1fr 1fr; gap:.875rem; margin-bottom:1rem; }
  .emp-edit-toggle-row {
    display:flex; align-items:center; justify-content:space-between;
    padding:.75rem 1rem; background:var(--bg-1); border:1px solid var(--line);
    border-radius:10px; margin-bottom:1rem;
  }
  .emp-toggle {
    position:relative; width:42px; height:24px; cursor:pointer;
    background:var(--line-2); border-radius:12px; border:none;
    transition:background .2s; flex-shrink:0;
  }
  .emp-toggle.on { background:var(--green); }
  .emp-toggle::after {
    content:''; position:absolute; top:3px; left:3px;
    width:18px; height:18px; border-radius:50%; background:#fff;
    transition:transform .2s;
  }
  .emp-toggle.on::after { transform:translateX(18px); }
  .emp-edit-actions { display:flex; gap:.625rem; justify-content:flex-end; margin-top:.25rem; }

  .user-edit-role-row { display:flex; gap:.5rem; margin-bottom:1rem; }
  .user-role-btn {
    flex:1; padding:8px; border-radius:9px; border:1px solid var(--line-2);
    background:transparent; font-family:var(--body); font-size:.82rem; font-weight:600;
    color:var(--text-2); cursor:pointer; transition:all .14s; text-align:center;
  }
  .user-role-btn.active-user  { background:rgba(79,142,247,.12); border-color:rgba(79,142,247,.4); color:var(--blue); }
  .user-role-btn.active-admin { background:rgba(245,158,11,.12); border-color:rgba(245,158,11,.4); color:var(--amber); }

  .analytics-grid {
    display:grid; grid-template-columns:repeat(auto-fill,minmax(240px,1fr)); gap:1rem;
    margin-bottom:1.25rem;
  }
  .analytics-card {
    background:var(--bg-1); border:1px solid var(--line); border-radius:12px;
    padding:1.125rem 1.25rem;
  }
  .analytics-card-label { font-size:.72rem; font-weight:700; letter-spacing:.07em; text-transform:uppercase; color:var(--text-3); margin-bottom:.375rem; }
  .analytics-card-num { font-size:2rem; font-weight:800; font-family:var(--display); color:var(--text-1); line-height:1; margin-bottom:.25rem; }
  .analytics-card-sub { font-size:.78rem; color:var(--text-3); }
  .analytics-bar-wrap { margin-top:.875rem; }
  .analytics-bar-row { display:flex; align-items:center; gap:.5rem; margin-bottom:.35rem; }
  .analytics-bar-label { font-size:.76rem; color:var(--text-2); min-width:60px; }
  .analytics-bar-track { flex:1; height:6px; background:var(--surface); border-radius:3px; overflow:hidden; }
  .analytics-bar-fill { height:100%; border-radius:3px; transition:width .4s ease; }
  .analytics-bar-val { font-size:.76rem; color:var(--text-3); min-width:20px; text-align:right; }

  .bulk-toolbar {
    display:flex; align-items:center; gap:.625rem; padding:.625rem 1rem;
    background:rgba(79,142,247,.07); border:1px solid rgba(79,142,247,.25);
    border-radius:10px; margin-bottom:.875rem; flex-wrap:wrap;
  }
  .bulk-count { font-size:.82rem; font-weight:600; color:var(--blue); margin-right:.25rem; }
  .bulk-spacer { flex:1; }

  .confirm-delete-bar {
    background:rgba(239,68,68,.10); border:1px solid rgba(239,68,68,.35);
    border-radius:10px; padding:.875rem 1rem; margin-bottom:.875rem;
    display:flex; align-items:center; justify-content:space-between; gap:.5rem;
  }
  .confirm-delete-bar span { font-size:.85rem; color:var(--red); font-weight:600; }

  tr.row-selected td { background:rgba(79,142,247,.06); }

  /* Home button */
 .dash-home-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 6px 13px;
  width: 100%;
  text-align: left;

  border-radius: 9px;
  border: 1px solid rgba(79, 142, 247, 0.2);

  background: rgba(79, 142, 247, 0.08);
  color: var(--blue);

  font-family: var(--body);
  font-size: 0.82rem;
  font-weight: 600;

  cursor: pointer;
  white-space: nowrap;

  transition: background 0.13s, border-color 0.13s;
}
  .dash-home-btn:hover { background:rgba(79,142,247,.16); border-color:rgba(79,142,247,.4); }

  /* Interview sent state */
  .interview-sent-btn {
    display:inline-flex; align-items:center; gap:5px;
    padding:5px 11px; border-radius:8px; font-size:.76rem; font-weight:700;
    background:rgba(34,197,94,.12); border:1px solid rgba(34,197,94,.3);
    color:var(--green); cursor:default; white-space:nowrap;
  }

  /* ── Export bar ─────────────────────────────────────────────────────────── */
  .export-bar {
    display:flex; align-items:center; gap:.625rem; flex-wrap:wrap;
    padding:.75rem 1rem; margin-bottom:.875rem;
    background:var(--bg-1); border:1px solid var(--line);
    border-radius:12px;
  }
  .export-bar-label {
    font-size:.74rem; font-weight:700; letter-spacing:.06em;
    text-transform:uppercase; color:var(--text-3); margin-right:.25rem;
    white-space:nowrap;
  }
  .export-btn {
    display:inline-flex; align-items:center; gap:6px;
    padding:6px 13px; border-radius:9px; font-family:var(--body);
    font-size:.82rem; font-weight:600; cursor:pointer;
    transition:all .15s; white-space:nowrap; border:1px solid transparent;
  }
  .export-btn-excel {
    background:rgba(21,128,61,.12); border-color:rgba(21,128,61,.3);
    color:#15803d;
  }
  .export-btn-excel:hover:not(:disabled) {
    background:rgba(21,128,61,.2); border-color:rgba(21,128,61,.5);
  }
  .export-btn-json {
    background:rgba(124,58,237,.1); border-color:rgba(124,58,237,.3);
    color:#7c3aed;
  }
  .export-btn-json:hover:not(:disabled) {
    background:rgba(124,58,237,.2); border-color:rgba(124,58,237,.5);
  }
  .export-btn:disabled { opacity:.45; cursor:not-allowed; }
  .export-btn svg { flex-shrink:0; }
  .export-note {
    margin-left:auto; font-size:.73rem; color:var(--text-3); white-space:nowrap;
  }

  @media (max-width:640px) {
    .ql-filter-bar { gap:.5rem; padding:.75rem; }
    .ql-divider { display:none; }
    .ql-meta { width:100%; justify-content:space-between; margin-left:0; }
    .ql-filter-select { flex:1; }
    .emp-edit-grid { grid-template-columns:1fr; }
    .analytics-grid { grid-template-columns:1fr 1fr; }
    .export-bar { flex-direction:column; align-items:flex-start; }
    .export-note { margin-left:0; }
  }
  @media (max-width:400px) {
    .analytics-grid { grid-template-columns:1fr; }
  }
`;

export { STYLES };
